var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 68,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.583 2.365v13.252c0 1.797 0 2.695.35 3.381a3.208 3.208 0 0 0 1.402 1.402c.686.35 1.585.35 3.382.35h13.252M17.542 43.208l9.625 9.625m0 0 9.625-9.625m-9.625 9.625v-19.25M33.583 1.5H16.9c-5.39 0-8.086 0-10.145 1.05A9.625 9.625 0 0 0 2.55 6.754C1.5 8.815 1.5 11.51 1.5 16.9v33.367c0 5.39 0 8.085 1.05 10.144a9.625 9.625 0 0 0 4.205 4.207c2.06 1.049 4.754 1.049 10.145 1.049h20.533c5.39 0 8.086 0 10.145-1.05a9.625 9.625 0 0 0 4.206-4.206c1.05-2.059 1.05-4.754 1.05-10.144V20.75L33.583 1.5Z",
  stroke: "#2C4145",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgFileDownload;